// extracted by mini-css-extract-plugin
module.exports = {"container":"b13981c874--container--WdudB"};